import React from 'react'
import { Button, Typography } from '@material-ui/core'
import clsx from 'clsx'
import { SectionLayoutDialog } from 'shared'

import { useStyles } from './ConflictUpdateDistanceDialog.style'

const DIALOG_STATES = {
  INFO: 'Info',
  ALERT: 'Alert'
}

const ConflictUpdateDistanceDialog = ({
  open,
  onClose,
  onRemoveDistances,
  state = DIALOG_STATES.INFO
}) => {
  const classes = useStyles()

  return (
    <SectionLayoutDialog
      open={open}
      title='NOTIFICACIÓN'
      className={classes.dialog}
      contentClassName={classes.container}>
      {state === DIALOG_STATES.INFO && (
        <>
          <Typography color='primary' variant='h6' align='center' className={classes.text}>
            Tus distancias se encuentran ya asociadas con categorías, si aplicas este cambio se
            borrarán todas las distancias creadas.
          </Typography>
          <div className={classes.buttonContainer}>
            <Button
              color='primary'
              variant='contained'
              className={classes.button}
              onClick={onClose}>
              Cancelar
            </Button>
            <Button
              color='primary'
              variant='contained'
              className={classes.button}
              onClick={onRemoveDistances}>
              Aplicar
            </Button>
          </div>
        </>
      )}

      {state === DIALOG_STATES.ALERT && (
        <>
          <Typography color='primary' variant='h6' align='center' className={classes.text}>
            Alguna de las distancias poseen inscripciones asociadas, no puedes aplicar estas
            modificaciones.
          </Typography>
          <div className={clsx(classes.buttonContainer, 'center')}>
            <Button
              color='primary'
              variant='contained'
              className={classes.button}
              onClick={onClose}>
              Aceptar
            </Button>
          </div>
        </>
      )}
    </SectionLayoutDialog>
  )
}

export default ConflictUpdateDistanceDialog
